import { GridColDef } from "@mui/x-data-grid";

import DataGridTextHeader from "../../molecules/DataGridTextHeader";

export const insuranceInformationColumns: GridColDef[] = [
  {
    field: "firstName",
    headerName: "First Name",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "lastName",
    headerName: "Last Name",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "gender",
    headerName: "Gender",
    width: 75,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "id",
    headerName: "Insurance Customer ID/ Client ID/Member ID",
    width: 225,
    sortable: false,
    disableColumnMenu: true,
    renderCell: item =>
      item.row.memberId || item.row.clientId || item.row.customerId,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "dob",
    headerName: "DOB on Client ID",
    width: 107,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "policyNumber",
    headerName: "Policy Numbers visible in app",
    width: 141,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "phoneNumber",
    headerName: "Phone on Policy",
    width: 118,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "email",
    headerName: "Email on Policy",
    width: 384,
    sortable: false,
    disableColumnMenu: true,
  },
];
